import {
  IconAnalytics,
  IconBell,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconShareGray,
  IconWarning,
} from '@assets/images/icon';
import { rtlsSystem3 } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailExhibition/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/retailExhibition/img/1.avif';
import image2 from '@src/assets/images/solution/retailExhibition/img/2.avif';
import image3 from '@src/assets/images/solution/retailExhibition/img/3.avif';
import image4 from '@src/assets/images/solution/retailExhibition/img/4.avif';
import image5 from '@src/assets/images/solution/retailExhibition/img/5.avif';

export default {
  type: 'Giải pháp bán lẻ',

  banner: {
    title: 'Theo dõi vị trí khách tham quan và tự động hóa hướng dẫn tác phẩm.',
    desc: 'Theo dõi vị trí khách tham quan theo thời gian thực thông qua thẻ UWB đeo cổ và tự động phát thông tin hướng dẫn cá nhân hóa khi họ tiếp cận tác phẩm, nâng cao trải nghiệm tham quan.',
  },

  video: {
    title: 'Khi đứng trước tác phẩm, hướng dẫn tự động bắt đầu.',
    desc: 'Khi khách tham quan tiếp cận gần tác phẩm, hệ thống sẽ tự động phát phần giới thiệu. Không cần người hướng dẫn, khách tham quan có thể hiểu ngay tác phẩm, mang đến trải nghiệm bảo tàng sống động và tiện lợi hơn.',
    play: video,
  },

  func: [
    {
      theme: 'Cung cấp hướng dẫn tác phẩm tự động theo vị trí khách tham quan.',
      title: 'Xác định vị trí khách tham quan theo thời gian thực',
      desc: 'Theo dõi vị trí khách tham quan bằng thẻ UWB đeo cổ với độ chính xác ±20cm. Khi khách tham quan tiếp cận tác phẩm, hệ thống sẽ ngay lập tức bắt đầu hướng dẫn.',
      sub1: 'Giám sát trạng thái theo thời gian thực',
      icon1: IconClockGray,
      sub2: 'Kết nối dữ liệu nhanh',
      icon2: IconShareGray,
      video: subVideo1,
    },
    {
      title: 'Hướng dẫn cá nhân tự động khi tiếp cận tác phẩm',
      desc: 'Khi khách tham quan đến gần một tác phẩm cụ thể, phần giới thiệu sẽ tự động phát. Khách không cần thao tác gì vẫn có thể nhận thông tin chi tiết.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      image: image1,
    },
    {
      title: 'Phân tích lộ trình di chuyển bằng thẻ tham quan',
      desc: 'Phân tích lộ trình di chuyển và dữ liệu lưu trú của khách tham quan thông qua thẻ, từ đó nắm bắt mối quan tâm thực tế, tối ưu hóa kế hoạch và hiệu quả triển lãm.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Kết nối dữ liệu nhanh',
      icon2: IconChainLinkGray,
      image: image2,
    },
    {
      title: 'Cảnh báo ngay khi vào khu vực nguy hiểm',
      desc: 'Khi khách tham quan vượt rào hoặc vào khu vực cấm, hệ thống sẽ ngay lập tức gửi cảnh báo đến quản lý. Giám sát theo thời gian thực giúp phòng tránh sự cố an toàn.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Kết nối dữ liệu nhanh',
      icon2: IconChainLinkGray,
      video: subVideo3,
    },
    {
      theme: 'Sử dụng dữ liệu khách tham quan để quản lý triển lãm hiệu quả.',
      title: 'Phân tích tự động mức độ quan tâm theo tác phẩm',
      desc: 'Hình ảnh hóa khu vực khách lưu trú lâu nhất bằng bản đồ nhiệt để phân tích tỷ lệ sử dụng không gian trực quan, xác định chính xác khu vực và tác phẩm thu hút.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: 'Hỗ trợ lập kế hoạch nội dung dựa trên dữ liệu',
      desc: 'Phân tích lộ trình và dữ liệu lưu trú của khách tham quan để áp dụng thiết thực cho các kế hoạch triển lãm tiếp theo, phản ánh đúng sở thích thực tế, tối ưu hiệu quả triển lãm.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
    {
      title: 'Phân tích tự động mức độ quan tâm sản phẩm trong cửa hàng',
      desc: 'Phân tích thời gian lưu trú và lộ trình di chuyển của khách trong cửa hàng lưu niệm để đo lường mức độ quan tâm từng sản phẩm một cách khách quan, tối ưu hóa trưng bày và tăng doanh thu.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: 'Hỗ trợ tối ưu hóa bố trí không gian',
      desc: 'Dựa trên dữ liệu tập trung của khách tham quan, triển khai điều chỉnh bố trí nhân sự theo thời gian thực, nâng cao hiệu suất lao động và giảm chi phí vận hành.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image5,
    },
  ],

  subfunc: {
    title: 'Tóm tắt tính năng chính',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: 'Theo dõi vị trí khách tham quan',
        desc: 'Theo dõi vị trí thẻ tham quan của khách theo thời gian thực.',
      },
      {
        icon: IconBell,
        title: 'Cung cấp hướng dẫn tự động',
        desc: 'Khi khách tiếp cận tác phẩm, hệ thống tự động phát thông tin hướng dẫn.',
      },
      {
        icon: IconRoute,
        title: 'Ghi lại lộ trình di chuyển',
        desc: 'Tự động ghi lại và phân tích lộ trình và thời gian lưu trú của khách theo từng tác phẩm.',
      },
      {
        icon: IconWarning,
        title: 'Cảnh báo tiếp cận khu vực nguy hiểm',
        desc: 'Khi khách vào khu vực cấm, hệ thống ngay lập tức thông báo cho quản lý.',
      },
      {
        icon: IconAnalytics,
        title: 'Phân tích mức độ quan tâm tác phẩm',
        desc: 'Trực quan hóa vị trí và thời gian lưu trú bằng bản đồ nhiệt để phân tích mức độ quan tâm.',
      },
      {
        icon: IconPenSquare,
        title: 'Hỗ trợ lập kế hoạch nội dung triển lãm',
        desc: 'Phân tích dữ liệu khách tham quan, phản ánh sở thích vào kế hoạch triển lãm.',
      },
      {
        icon: IconSearch,
        title: 'Phân tích mức độ quan tâm sản phẩm cửa hàng',
        desc: 'Phân tích dữ liệu lưu trú trong cửa hàng để biết sản phẩm nào được yêu thích.',
      },
      {
        icon: IconDashboard,
        title: 'Tối ưu hóa phân bổ nhân sự theo thời gian thực',
        desc: 'Phân tích dữ liệu tập trung của khách theo thời gian thực, hỗ trợ bố trí nhân sự hiệu quả.',
      },
      {
        icon: IconLayers,
        title: 'Đo lường tỷ lệ khách quay lại',
        desc: 'Phân tích tần suất quay lại và hành vi để đánh giá mức độ trung thành.',
      },
      {
        icon: IconChartBar,
        title: 'Đo lường hiệu quả sự kiện',
        desc: 'Tự động thu thập dữ liệu khách trước và sau sự kiện để đánh giá hiệu quả.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem3,
  },

  productTitle: 'Gói sản phẩm',
  product: [
    {
      tag: 'peoplePackage',
    },
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'manufacturingSteel',
    },
    {
      data: 'logisticsSafety',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
